var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.445 166.216C403.358 152.308 389.704 141.988 373.818 137.131C351.748 130.383 328.152 126.177 303.585 126.177C241.594 126.177 186.072 152.414 145.006 179.786C140.45 182.821 139.951 189.331 143.942 193.078L210.917 256L119.668 298.143C113.899 300.806 112.941 308.638 117.934 312.569C159.661 345.408 226.644 385.823 303.585 385.823C320.299 385.823 336.561 383.873 352.204 380.5C368.44 376.999 382.962 367.977 393.236 354.924L471.106 255.997L412.445 166.216Z",
    fill: "#0064BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.218 228.166C460.648 194.955 387.723 143.861 304.115 143.861C180.247 143.861 79.8345 256 79.8345 256C79.8345 256 180.247 368.142 304.115 368.142C387.723 368.142 460.648 317.047 499.218 283.835C516.262 269.157 516.262 242.84 499.218 228.166Z",
    fill: "#0055B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.115 143.861C180.247 143.861 79.8345 256 79.8345 256C79.8345 256 98.0997 276.391 128.646 299.781H330.816C354.331 299.781 373.393 280.72 373.393 257.204V155.025C351.573 148.146 328.297 143.861 304.115 143.861ZM312.36 265.936C300.178 265.936 290.302 256.06 290.302 243.878C290.302 231.695 300.178 221.82 312.36 221.82C324.542 221.82 334.421 231.695 334.421 243.878C334.421 256.06 324.542 265.936 312.36 265.936Z",
    fill: "#444D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.503 273.708C451.276 273.708 464.873 260.11 464.873 243.337C464.873 226.564 451.276 212.967 434.503 212.967C417.73 212.967 404.132 226.564 404.132 243.337C404.132 260.11 417.73 273.708 434.503 273.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.505 258.521C442.891 258.521 449.689 251.723 449.689 243.337C449.689 234.951 442.891 228.153 434.505 228.153C426.119 228.153 419.321 234.951 419.321 243.337C419.321 251.723 426.119 258.521 434.505 258.521Z",
    fill: "#814C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.585 224.481L13.7252 175.645C7.44459 172.443 0.000976562 177.006 0.000976562 184.056V309.239C0.000976562 316.287 7.44459 320.852 13.7252 317.65L109.585 268.814C127.698 259.588 127.698 233.708 109.585 224.481Z",
    fill: "#444D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5378 237.638L0.000976562 192.532V300.763L88.5378 255.655C95.8993 251.905 95.8993 241.39 88.5378 237.638Z",
    fill: "#FFD224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.008 265.748L271.127 218.866C236.814 253.179 236.814 308.81 271.127 343.123L318.008 296.241C326.427 287.82 326.427 274.169 318.008 265.748Z",
    fill: "#FFD224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.008 265.748L280.148 227.888C250.818 257.218 250.818 304.773 280.148 334.104L318.008 296.244C326.427 287.82 326.427 274.169 318.008 265.748Z",
    fill: "#0063BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDori);
export default __webpack_public_path__ + "static/media/dori.5f7af00806d1648a93439a959795da7e.svg";
export { ForwardRef as ReactComponent };